import Alert from 'svgs/summit/alert.svg';

import { TrackedPhoneNumber } from '@/components/TrackedPhoneNumber';

import { FC } from 'react';

import styles from './index.module.scss';

export const Error: FC = () => {
  return (
    <div className="summit-wrapper">
      <div className={styles['error-hero-container']}>
        <div className={`container ${styles['main']}`}>
          <div className={styles['icon-container']}>
            <Alert />
          </div>
          <h1>We&apos;re sorry...</h1>
          <h2>But we couldn&apos;t complete your request</h2>
          <p>
            Unfortunately we don&apos;t have a professional ready to take your call right now. Please call us on <TrackedPhoneNumber className={styles['phone-number']} /> so that we can get some more
            information and connect you with a professional.
          </p>
        </div>
      </div>
    </div>
  );
};
